import {DDR} from './ddr.class';

export class DDRWoman1418Strategy extends DDR {
  constructor() {
    super([700, 5, 15, 75, 65, 1, 1, 14, 1.3, 400, 2.4, 5, 25, 400, 1300, 24, 890, 3, 150, 15, 360, 1.6, 1250, 55, 9]);
  }
}
